import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    InstalacionHistorial: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_INSTALACIONES_HISTORIAL = 'GET_ALL_INSTALACIONES_HISTORIAL'
const GET_INSTALACION_HISTORIAL_BY_ID = 'GET_INSTALACION_HISTORIAL_BY_ID'
const POST_INSTALACION_HISTORIAL = 'POST_INSTALACION_HISTORIAL'
const UPDATE_INSTALACION_HISTORIAL = 'UPDATE_INSTALACION_HISTORIAL'
const DELETE_INSTALACION_HISTORIAL = 'DELETE_INSTALACION_HISTORIAL'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllInstalacionHistorials = createAsyncThunk(
    GET_ALL_INSTALACIONES_HISTORIAL,
    async () => {
        try {
            const fullUrl = host + `Fi25anexoInstalacionHistorial/obtenerInstalacionesHistorial`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las InstalacionHistorials: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getInstalacionHistorialById = createAsyncThunk(
    GET_INSTALACION_HISTORIAL_BY_ID,
    async (idInstalacionHistorial) => {
        try {
            const fullUrl = host + `Fi25anexoInstalacionHistorial/obtenerInstalacionHistorialById/${idInstalacionHistorial}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertInstalacionHistorial = createAsyncThunk(
    POST_INSTALACION_HISTORIAL,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexoInstalacionHistorial/agregarInstalacionHistorial`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateInstalacionHistorial = createAsyncThunk(
    UPDATE_INSTALACION_HISTORIAL,
    async (data) => {
        try {
            const fullUrl = host + `Fi25anexoInstalacionHistorial/actualizarInstalacionHistorial`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteInstalacionHistorial = createAsyncThunk(
    DELETE_INSTALACION_HISTORIAL,
    async (idInstalacionHistorial) => {
        try {
            const fullUrl = host + `Fi25InstalacionHistorial/eliminarInstalacionHistorial/${idInstalacionHistorial}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosInstalacionHistorialSlice = createSlice({

    name: 'metodosInstalacionHistorialSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllInstalacionHistorials.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.InstalacionHistorial = payload.data.data

        },
        [getInstalacionHistorialById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.InstalacionHistorial = payload.data.data
        },
        [insertInstalacionHistorial.fulfilled]: (state, { payload }) => {
            state.InstalacionHistorial = payload.data.data
        },

        [updateInstalacionHistorial.fulfilled]: (state, { payload }) => {

        },
        [deleteInstalacionHistorial.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosInstalacionHistorialSlice.actions
export const InstalacionHistorialReducer = metodosInstalacionHistorialSlice.reducer